import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MenuLink from '../MenuLink/MenuLink';
import { X, ChevronRight, BookOpen, Phone, Ruler, FileText, User } from 'lucide-react';
import './MobileDrawer.css';

const secondaryLinks = [
  { name: "Size Measurement Guide", path: "/size-guide", icon: Ruler },
  { name: "The ZIDA Story", path: "/about", icon: BookOpen },
  { name: "Customer Support & FAQs", path: "/contact", icon: Phone },
  { name: "My Account & Orders", path: "/account", icon: User },
  { name: "Shipping & Return Policies", path: "/policies/shipping", icon: FileText }
];

// Menu links, logo and offer line come from Admin → Customize → Header.
const MobileDrawer = ({ isOpen, onClose, navLinks = [], logo, logoAlt, promoText, promoCode, themeStyle }) => {
  // Lock body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="mobile-drawer-backdrop" onClick={onClose}>
      <aside
        className="mobile-drawer-panel"
        style={themeStyle}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile Navigation Menu"
      >
        {/* Drawer Header */}
        <div className="drawer-header">
          <div className="drawer-brand">
            <img
              src={logo || '/images/sha-botique-logo.png'}
              alt={logoAlt || 'ZIDA'}
              className="drawer-logo-img"
            />
          </div>
          <button
            className="drawer-close-btn"
            onClick={onClose}
            aria-label="Close navigation menu"
          >
            <X size={22} />
          </button>
        </div>

        {/* Promo strip inside drawer */}
        {(promoText || promoCode) && (
          <div className="drawer-promo">
            <span>{promoText} {promoCode && <strong>{promoCode}</strong>}</span>
          </div>
        )}

        {/* Category Navigation */}
        <div className="drawer-scroll-content">
          <div className="drawer-section">
            <h3 className="drawer-section-title">Shop</h3>
            <ul className="drawer-category-list">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <MenuLink
                    link={link}
                    className={isActive => `drawer-cat-link ${isActive ? 'active' : ''} ${link.highlight ? 'highlight' : ''}`}
                    onClick={onClose}
                  >
                    <span>{link.label}</span>
                    <ChevronRight size={16} className="drawer-arrow" />
                  </MenuLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Services & Help */}
          <div className="drawer-section">
            <h3 className="drawer-section-title">Customer Care & Info</h3>
            <ul className="drawer-secondary-list">
              {secondaryLinks.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.path}>
                    <Link to={item.path} className="drawer-sec-link" onClick={onClose}>
                      <Icon size={16} className="drawer-sec-icon" />
                      <span>{item.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Drawer Footer Details */}
          <div className="drawer-footer">
            <p className="drawer-footer-text">Pure Cotton Comfort • Inclusive Sizes XS to 5XL</p>
            <p className="drawer-footer-copy">© 2026 ZIDA Ethnic Wear.</p>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default MobileDrawer;
